// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hGW6G","left":"styles_left__kcY4f","desktopActions":"styles_desktopActions__3kPrn","title":"styles_title__2H8Dy"};